<template>
  <div class="main" v-loading="loading">
    <home-head></home-head>
    <div class="banner bannerpc pc">
      <Swiper :options="swiperOption" ref="mySwiper">
        <Swiper-slide v-for="item in bannerData" :key="item.id">
          <a href="javascript:;" v-if="!item.linkUrl" target="_self" title>
            <img :src="item.imageUrl" width="100%" />
          </a>
          <a :href="item.linkUrl" v-else target="_self" title>
            <img :src="item.imageUrl" width="100%" />
          </a>
        </Swiper-slide>
      </Swiper>
      <div class="bnqhc clearfix">
        <a href="javascript:;" class="bnqh bnqh1" role="button">
          <img src="/static/qh1.png" />
        </a>
        <a href="javascript:;" class="bnqh bnqh2" role="button">
          <img src="/static/qh2.png" />
        </a>
      </div>
      <!-- <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span> -->
    </div>

    <div class="banner bannersj sj" v-if="isMobileFlag">
      <Swiper :options="swiperOptionSj" ref="mySwiperSj">
        <Swiper-slide v-for="item in bannerData" :key="item.id">
          <a href="javascript:;" v-if="!item.linkUrl" target="_self" title>
            <img :src="item.imageUrl" width="100%" />
          </a>
          <a :href="item.linkUrl" v-else target="_self" title>
            <img :src="item.imageUrl" width="100%" />
          </a>
        </Swiper-slide>
      </Swiper>
      <div class="bnqhc clearfix">
        <a href="javascript:;" class="bnqh bnqh1 bnqhsj1" role="button">
          <img src="static/qh1.png" />
        </a>
        <a href="javascript:;" class="bnqh bnqh2 bnqhsj2" role="button">
          <img src="static/qh2.png" />
        </a>
      </div>
      <!-- <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div> -->
    </div>

    <div class="conBox">
      <div class="waps clearfix">
        <div class="news clearfix">
          <div class="htit animation srcospcur">
            <h3>最新资讯</h3>
            <p>NEWS</p>
          </div>

          <div
            class="nleft animation swiper-container-horizontal swiper-container-ios srcospcur"
            v-if="newsData"
          >
            <Swiper :options="swiperOptionNews" ref="mySwiperNews">
              <Swiper-slide v-for="news in newsData" :key="news.id">
                <div class="img">
                  <router-link
                    :to="{name:'news',params:{pId:news.node.parentId,cId:news.node.nodeId},query:{id:news.id}}"
                    :title="news.imageUrl"
                    :style="{background:'url('+news.imageUrl+') no-repeat center center /contain'}"
                  ></router-link>
                </div>
                <div class="txt">
                  <span>{{news.addDate.split(' ')[0]}}</span>
                  <h3 class="ft26">
                    <a href="#" title>{{news.listTitle}}</a>
                  </h3>
                  <router-link
                    :to="{name:'news',params:{pId:news.node.parentId,cId:news.node.nodeId}}"
                    class="more"
                  >了解更多</router-link>
                </div>
              </Swiper-slide>
            </Swiper>

            <div class="nleftqh"></div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>

          <div class="nright animation srcospcur" v-if="newsDataHun.length>0">
            <ul>
              <li class="clearfix" v-for="(news,index) in newsDataHun" :key="news.id">
                <div class="lic">
                  <img src="static/xwico1.png" />
                  <!-- <p>{{index%2==0?"新闻":"党建"}}</p> -->
                  <p>新闻</p>
                </div>
                <div class="txt">
                  <router-link
                    :to="{name:index%2==0?'news':'party',params:{pId:news.node.parentId,cId:news.node.nodeId},query:{id:news.id}}"
                    title
                  >
                    <span>{{news.addDate.split(' ')[0]}}</span>
                    <h3>{{news.listTitle}}</h3>
                    <p></p>
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <div class="film animation srcospcur" v-if="videoNavData">
            <div class="htit">
              <h3>公司形象片</h3>
              <p>Company image film</p>
              <router-link
                :to="{name:'news',params:{pId:videoNavData[0].node.parentId,cId:videoNavData[0].node.nodeId},query:{type:'cpy',vid:videoNavData[0].id}}"
                title
              >
                更多
                <img src="/static/more1.png" />
              </router-link>
            </div>
            <div class="con">
              <router-link
                :to="{name:'news',params:{pId:videoNavData[0].node.parentId,cId:videoNavData[0].node.nodeId},query:{type:'cpy',vid:videoNavData[0].id}}"
                title
              >
                <img :src="videoData.imageUrl" width="100%" />
                <div class="zhz whbfb"></div>
              </router-link>
            </div>
          </div>

          <div class="culture animation" v-if="companyCultureNavData">
            <div class="htit">
              <h3>企业文化</h3>
              <p>company culture</p>
              <router-link
                :to="{name:'team',params:{pId:companyCultureNavData.parentId,cId:companyCultureNavData.nodeId}}"
                title
              >
                更多
                <img src="/static/more1.png" />
              </router-link>
            </div>
            <div class="con clearfix">
              <router-link
                :to="{name:'team',params:{pId:companyCultureNavData.parentId,cId:companyCultureNavData.nodeId}}"
                title
              >
                <img :src="companyCultureData.imageUrl" />
                <div class="txt" v-html="companyCultureData.content"></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="jysj ptb80"
      v-if="realRunData"
      :style="{background:'url('+realRunData.imageUrl+') no-repeat center',backgroundSize:'cover',backgroundAttachment:'fixed'}"
    >
      <div class="wap">
        <div class="tit ft40 animation srcospcur">
          <span></span>
          <font>经营实绩</font>
          <span></span>
        </div>
        <ul class="clearfix animation srcospcur">
          <li>
            <div class="ico">
              <img src="/static/20181206121621.png" />
            </div>
            <div class="txt">
              <h3 class="ft60">152.3</h3>
              <p>营业收入（亿元）</p>
            </div>
          </li>

          <li>
            <div class="ico">
              <img src="/static/20181206121655.png" />
            </div>
            <div class="txt">
              <h3 class="ft60">220</h3>
              <p>劳动生产率（万元/人）</p>
            </div>
          </li>

          <li>
            <div class="ico">
              <img src="/static/20181206121726.png" />
            </div>
            <div class="txt">
              <h3 class="ft60">132.5</h3>
              <p>公司价值（亿元）</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="swditu" v-if="managementNavData">
      <img :src="managementData.imageUrl" width="100%" />
      <router-link
        :to="{name:'management',params:{pId:managementNavData.parentId,cId:managementNavData.nodeId}}"
        class="whbfb"
      >
        <div class="table">
          <div class="table-cell">
            <div class="tit ft40 animation">
              <span></span>
              <font>全球化发展</font>
              <span></span>
            </div>
          </div>
        </div>
      </router-link>
    </div>

    <div class="swditu">
      <img :src="productData.imageUrl" width="100%" />
      <router-link
        :to="{name:'product',params:{pId:productNavData.parentId,cId:productNavData.nodeId}}"
        class="whbfb"
      >
        <div class="table">
          <div class="table-cell">
            <div class="tit ft40 animation">
              <span></span>
              <font>产品与业务</font>
              <span></span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import homeHead from "@/components/head";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getMenu, getNewsList } from "@/api/index";
export default {
  components: {
    homeHead,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      partyNewsData: null,
      loading: false,
      videoData: { imageUrl: "" },
      videoNavData: null,
      companyCultureData: {},
      companyCultureNavData: null,
      realRunData: null, //经营实绩
      managementData: {},
      managementNavData: null, //全球发展
      productData: {},
      productNavData: null, //产品与业务
      bannerData: [],
      newsData: null,
      swiperOption: {
        autoplay: 5000,
        loop: true,
        nextButton: ".bnqh2",
        prevButton: ".bnqh1"
      },
      swiperOptionSj: {
        autoplay: 5000,
        nextButton: ".bnqhsj2",
        prevButton: ".bnqhsj1"
      },
      swiperOptionNews: {
        autoplay: 5000,
        loop: true,
        pagination: ".nleftqh",
        paginationClickable: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : "";
    },
    swiperSj() {
      return this.$refs.mySwiperSj ? this.$refs.mySwiperSj.$swiper : "";
    },
    isMobileFlag() {
      let flag = this.$utils.isMobile();
      return flag;
    },
    newsDataHun() {
      // 党建、新闻 混排
      let arr = [];
      if (!!this.newsData && !!this.partyNewsData) {
          for (const key in this.newsData) {
              if (key<4) {
                  arr.push(this.newsData[key])
              }
          }
        // arr.push(this.newsData[0]);
        // arr.push(this.partyNewsData[0]);
        // arr.push(this.newsData[1]);
        // arr.push(this.partyNewsData[1]);
      }
      return arr;
    }
  },
  created() {
    if (!localStorage.bwsteelMenus) {
      this.getMenuFun();
    } else {
      this.initFun();
    }
  },
  mounted() {
    // this.swiper.slideTo(2, 1000, false);
  },
  methods: {
    initFun() {
      let bannerNodeId = this.$utils.getChildNodeId("indexdata", "banner")
        .nodeId;
      // 获取banner
      this.getNewsListFun(
        {
          pageNo: 0,
          pageSize: 10,
          condition: {
            nodeId: bannerNodeId
          }
        },
        "banner"
      );
      // 最新资讯
      let newNodeId = this.$utils.getChildNodeId("mediacenter", "news").nodeId;
      this.getNewsListFun(
        {
          pageNo: 0,
          pageSize: 4,
          condition: {
            nodeId: newNodeId
            // isRecommend: 1
          }
        },
        "news"
      );
      let partyNodeId = this.$utils.getChildNodeId("party", "partynews").nodeId;
      this.getNewsListFun(
        {
          pageNo: 0,
          pageSize: 2,
          condition: {
            nodeId: partyNodeId
            // isRecommend: 1
          }
        },
        "newsParty"
      );

      // 公司形象片
      this.$set(
        this.$data,
        "videoData",
        this.$utils.getChildNodeId("indexdata", "COMPANY IMAGE FILM")
      );
      let videoNodeId = this.$utils.getChildNodeId(
        "mediacenter",
        "companyvideo"
      ).nodeId;
      // this.$set(
      //   this.$data,
      //   "videoNavData",
      //   this.$utils.getChildNodeId("mediacenter", "companyvideo")
      // );
      this.getNewsListFun(
        {
          pageNo: 0,
          pageSize: 1,
          condition: {
            nodeId: videoNodeId
            // isRecommend: 1
          }
        },
        "video"
      );
      // 企业文化
      this.$set(
        this.$data,
        "companyCultureData",
        this.$utils.getChildNodeId("indexdata", "COMPANY CULTURE")
      );
      this.$set(
        this.$data,
        "companyCultureNavData",
        this.$utils.getChildNodeId(
          "companyculture",
          this.companyCultureData.linkUrl || "growth"
        )
      );
      // 经营实绩
      this.$set(
        this.$data,
        "realRunData",
        this.$utils.getChildNodeId("indexdata", "Business performance")
      );
      // 全球发展
      this.$set(
        this.$data,
        "managementData",
        this.$utils.getChildNodeId("indexdata", "globe")
      );
      this.$set(
        this.$data,
        "managementNavData",
        this.$utils.getChildNodeId("development", "map")
      );
      // 产品与业务
      this.$set(
        this.$data,
        "productData",
        this.$utils.getChildNodeId("indexdata", "Products and services")
      );
      this.$set(
        this.$data,
        "productNavData",
        this.$utils.getChildNodeId("Business", "Metalware")
      );
    },

    // 获取二级列表内容
    getNewsListFun(json, type) {
      this.loading = true;
      getNewsList(json).then(res => {
        this.loading = false;
        if (res.data.code == 1000) {
          switch (type) {
            case "banner":
              this.$set(this.$data, "bannerData", res.data.data.data);
              break;
            case "news":
              this.$set(this.$data, "newsData", res.data.data.data);
              break;
            case "newsParty":
              this.$set(this.$data, "partyNewsData", res.data.data.data);
              break;
            case "video":
              this.$set(this.$data, "videoNavData", res.data.data.data);
              break;

            default:
              break;
          }
        }
      });
    },
    getMenuFun() {
      getMenu().then(res => {
        if (res.data.code === 1000) {
          let datas = res.data.data[0].childs.map(item => {
            if (item.childs) {
              item.hasChilds = true;
            }
            item.path = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).url;
            item.pathName = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).name;
            return item;
          });
          localStorage.setItem("bwsteelMenus", JSON.stringify(datas));
          this.initFun();
        } else {
          this.$message.error("栏目获取失败！");
        }
      });
    }
  }
};
</script>